<template>
    <div :class="`chat from-${chat.role} animate-fadeIn`">
        <div class="chat-date">
            <v-icon v-if="chat.role=='ai'" icon="mdi-robot-outline"/>
            {{FormatDate}}
        </div>
        <div class="chat-bubble">
            <div class="chat-content" v-html="chat.message"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import moment from 'moment'
import type { AssistantChat } from '@/stores/globals'

const props = defineProps<{ chat: AssistantChat }>()

const FormatDate = computed(() => props.chat.timestamp ? moment(props.chat.timestamp).format('MMMM D, YYYY h:mm A') : '')
</script>
<style lang="scss">
.chat {
    display: flex;
    flex-direction: column;
    margin: 8px 10px;

    &.from-ai {
        align-items: flex-start;

        .chat-bubble {
            background: #ffffff;
            color: #1a1a2e;
            border-radius: 4px 18px 18px 18px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }
    }

    &.from-human {
        align-items: flex-end;

        .chat-bubble {
            background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
            color: #ffffff;
            border-radius: 18px 18px 4px 18px;
            box-shadow: 0 2px 8px rgba(59,130,246,0.25);
        }

        .chat-date {
            text-align: right;
        }
    }

    .chat-date {
        font-size: 11px;
        opacity: 0.5;
        margin-bottom: 5px;
        padding: 0 4px;

        .v-icon {
            position: relative;
            top: -2px;
            margin-right: 3px;
            font-size: 13px;
        }
    }

    .chat-bubble {
        max-width: 300px;
        width: fit-content;
        padding: 10px 14px;
        font-size: 14px;
        line-height: 1.55;

        ul {
            padding-left: 15px;
            margin: 4px 0;
        }
    }
}

/* Dark theme overrides */
.dark .chat.from-ai .chat-bubble,
#chat-ui.dark .chat.from-ai .chat-bubble {
    background: #1e1e30;
    color: #e8eaf0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}
</style>
